<div class="question">
  <e-segmented-toggle
    testId="iching-question-kind"
    [options]="kindOptions()"
    [value]="questionKind()"
    (valueChange)="questionKindChange.emit($event)"
  />

  @if (questionKind() === 'situation' && step().situationHint; as hint) {
    <p class="hint">{{ hint }}</p>
  }

  <textarea
    #questionInput
    class="text"
    rows="3"
    data-test-id="iching-question"
    [attr.maxlength]="maxLength"
    [placeholder]="t('humanDesign.iching.question.placeholder')"
    [value]="question()"
    (input)="questionChange.emit(questionInput.value)"
  ></textarea>

  @if (questionKind() === 'question') {
    <div class="tools">
      @if (step().tips?.length) {
        <button
          type="button"
          class="tips-toggle"
          data-test-id="iching-question-tips"
          [attr.aria-expanded]="tipsOpen()"
          (click)="tipsOpen.set(!tipsOpen())"
        >
          <i class="fas fa-lightbulb" aria-hidden="true"></i> {{ t('humanDesign.iching.question.tips') }}
        </button>
      }
    </div>
    @if (tipsOpen()) {
      <ul class="tips">
        @for (tip of step().tips ?? []; track $index) {
          <li>{{ tip }}</li>
        }
      </ul>
    }

    @if (step().examples?.length) {
      <span class="examples-label">{{ t('humanDesign.iching.question.examples') }}</span>
      <div class="examples">
        @for (example of step().examples ?? []; track $index) {
          <button type="button" class="chip" data-test-id="iching-question-example" (click)="useExample(example)">
            {{ example }}
          </button>
        }
      </div>
    }
  }

  @if (step().calm; as calm) {
    <p class="calm">{{ calm }}</p>
  }
</div>
